import cn from '../List.css.json';
import '../List.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListSeparator = () => /*#__PURE__*/_jsx("li", {
  role: "presentation",
  className: cn.itemSeparator
});
//# sourceMappingURL=ListSeparator.js.map